import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Info } from "lucide-react";
import "../styles/SplashScreen.css";

/**
 * SplashScreen component displays a polished modal overlay on first visit,
 * encouraging responsible use of the page contents.
 */
export default function SplashScreen() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("hasSeenSplash")) {
      setIsVisible(true);
    }
  }, []);

  const handleIUnderstand = () => {
    localStorage.setItem("hasSeenSplash", "true");
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="splash-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className="splash-modal"
            initial={{ y: -50, opacity: 0, scale: 0.8 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 50, opacity: 0, scale: 0.8 }}
            transition={{ type: "spring", stiffness: 250, damping: 20 }}
          >
            <Info className="splash-icon pulse" size={48} />
            <h2 className="splash-title">Welcome!</h2>
            <p className="splash-text">
              You’re about to access powerful insights—please use this
              information responsibly and ethically. Your actions based on these
              resources are your own. Thank you for being considerate.
            </p>
            <button
              type="button"
              onClick={handleIUnderstand}
              className="splash-btn"
            >
              I Understand
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
